import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import { Input } from '@/shared/components/ui/Input';
import { BrowseIntegrationCard } from './BrowseIntegrationCard';
import type { BrowseIntegration } from '../types';

interface BrowseTabProps {
  integrations: BrowseIntegration[];
  isImporting: boolean;
}

export const BrowseTab = ({ integrations, isImporting }: BrowseTabProps) => {
  const { t } = useTranslation('goals');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredIntegrations = useMemo(() => {
    if (!searchQuery.trim()) return integrations;
    const q = searchQuery.toLowerCase();
    return integrations.filter((i) =>
      String(t(i.nameKey as never))
        .toLowerCase()
        .includes(q)
    );
  }, [searchQuery, integrations, t]);

  return (
    <div className="flex-1 overflow-y-auto p-6">
      <div className="relative mb-5">
        <Search className="absolute start-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={t('integrationsDialog.searchPlaceholder')}
          className="ps-9"
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        {filteredIntegrations.map((item) => (
          <BrowseIntegrationCard
            key={item.id}
            integration={item}
            isImporting={item.id === 'msproject' && isImporting}
          />
        ))}
      </div>
    </div>
  );
};
